import React from 'react';

const variantClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700',
    secondary: 'border border-gray-300 text-gray-700 hover:bg-gray-50',
};

const FormCard = ({
    title,
    subtitle,
    status,
    statusClassName = '',
    meta = [],
    actions = [],
}) => {
    return (
        <div className="bg-white rounded-lg shadow p-4 space-y-3">
            <div className="flex justify-between items-start gap-3">
                <div className="min-w-0">
                    <div className="text-sm text-gray-500 truncate">{subtitle}</div>
                    <div className="text-lg font-semibold text-gray-900 break-all">{title}</div>
                </div>
                {status && (
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${statusClassName}`}>
                        {status}
                    </span>
                )}
            </div>

            <div className="space-y-2">
                {meta.map(({ label, value }) => (
                    <div key={label} className="flex justify-between items-start gap-3 text-sm">
                        <span className="text-gray-500 whitespace-nowrap">{label}</span>
                        <span className="text-gray-900 text-right break-words flex-1">{value || '-'}</span>
                    </div>
                ))}
            </div>

            {actions.length > 0 && (
                <div className="flex flex-wrap gap-2 pt-1">
                    {actions.map((action) => (
                        <button
                            key={action.label}
                            type="button"
                            onClick={action.onClick}
                            className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${variantClasses[action.variant || 'secondary']}`}
                        >
                            {action.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default FormCard;
